
	import Vue from "vue";

	import CalculateYourTaxes from "./views/CalculateYourTaxes.vue";
	import HomesteadExemptionCalculator from "./views/HomesteadExemptionCalculator.vue";
	import OwnerOccupancyCreditCalculator from "./views/OwnerOccupancyCreditCalculator.vue";
	import SchoolDistrictEstimator from "./views/SchoolDistrictEstimator.vue";
	import LevyEstimator from "./views/LevyEstimator.vue";
	import TaxRatesList from "./views/TaxRatesList.vue";
	import HomesteadSavings from "./views/HomesteadSavings.vue";
	import Reevaluation from "./views/Reevaluation.vue";

	export default Vue.extend({
		name: "Calculator",

		props: {
			calculatorName: String,
			disclaimer: String,
			note: String,
		},

		mounted() {},

		computed: {
			calculatorComponent() {
				let calculatorName = this.calculatorName;

				switch (calculatorName) {
					case "tax-calculator": // Done.
						return CalculateYourTaxes;
					case "owner-occupancy-credit-calculator":
						return OwnerOccupancyCreditCalculator;
					case "homestead-exemption-calculator": // Done.
						return HomesteadExemptionCalculator;
					case "levy-estimator": // Done.
						return LevyEstimator;
					case "school-district-estimator": // Done.
						return SchoolDistrictEstimator;
					case "tax-rates-list": // Done.
						return TaxRatesList;
					case "homestead-savings":
						return HomesteadSavings;
					case "reevaluation":
						return Reevaluation;
					default:
						return CalculateYourTaxes;
				}

				return null;
			},
		},
	});
